/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ itemName: NonNullable<unknown> }} Notifications_Message_Subject_Threshold_HitInputs */

const he_notifications_message_subject_threshold_hit = /** @type {(inputs: Notifications_Message_Subject_Threshold_HitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`הגיע למחיר היעד: ${i?.itemName}`)
};

const en_notifications_message_subject_threshold_hit = /** @type {(inputs: Notifications_Message_Subject_Threshold_HitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Target price reached: ${i?.itemName}`)
};

/**
* | output |
* | --- |
* | "Target price reached: {itemName}" |
*
* @param {Notifications_Message_Subject_Threshold_HitInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_subject_threshold_hit = /** @type {((inputs: Notifications_Message_Subject_Threshold_HitInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Subject_Threshold_HitInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_subject_threshold_hit(inputs)
	return en_notifications_message_subject_threshold_hit(inputs)
});